<template>
  <div class="page">
    <div class="page__bd">
      <div class="x-card">
        <h5 class="x-card-title">工商信息</h5>
        <div class="x-card-content" v-if="form.type == '内地'">
          <span class="x-card-content-title">企业名称</span>
          <p>{{ form.name }}</p>
          <span class="x-card-content-title">法定代表人</span>
          <p>{{ form.legalRepresentative }}</p>
          <span class="x-card-content-title">登记状态</span>
          <p>{{ form.registrationStatus }}</p>
          <span class="x-card-content-title">成立日期</span>
          <p>{{ form.establishmentDate }}</p>
          <span class="x-card-content-title">统一社会信用代码</span>
          <p>{{ form.uniSocCreIdentifier }}</p>
          <span class="x-card-content-title">注册资本</span>
          <p>{{ form.registeredCapital }}</p>
          <span class="x-card-content-title">实缴资本</span>
          <p>{{ form.paidInAmount }}</p>
          <span class="x-card-content-title">工商注册号</span>
          <p>{{ form.busRegistrationNumber }}</p>
          <span class="x-card-content-title">纳税人识别号</span>
          <p>{{ form.taxRegistrationNumber }}</p>
          <span class="x-card-content-title">组织机构代码</span>
          <p>{{ form.orgInsBarCode }}</p>
          <span class="x-card-content-title">营业期限</span>
          <p>{{ form.businessTerm }}</p>
          <span class="x-card-content-title">纳税人资质</span>
          <p>{{ form.taxQualifications }}</p>
          <span class="x-card-content-title">类型</span>
          <p>{{ form.type }}</p>
          <span class="x-card-content-title">企业类型</span>
          <p>{{ form.enterpriseType }}</p>
          <span class="x-card-content-title">行业</span>
          <p>{{ form.industry }}</p>
          <span class="x-card-content-title">人员规模</span>
          <p>{{ form.staffSize }}</p>
          <span class="x-card-content-title">参保人数</span>
          <p>{{ form.insuredNumber }}</p>
          <span class="x-card-content-title">英文名称</span>
          <p>{{ form.englishName }}</p>
          <span class="x-card-content-title">登记机关</span>
          <p>{{ form.registrationOrgan }}</p>
          <span class="x-card-content-title">注册地址</span>
          <p>{{ form.registeredAddress }}</p>
          <span class="x-card-content-title">经营范围</span>
          <p>{{ form.businessScope }}</p>
        </div>
        <div class="x-card-content" v-if="form.type == '事业单位'">
          <span class="x-card-content-title">单位名称</span>
          <p>{{ form.name }}</p>
          <span class="x-card-content-title">法定代表人</span>
          <p>{{ form.legalRepresentative }}</p>
          <span class="x-card-content-title">开办资金</span>
          <p>{{ form.registeredCapital }}</p>
          <span class="x-card-content-title">登记状态</span>
          <p>{{ form.registrationStatus }}</p>
          <span class="x-card-content-title">经费来源</span>
          <p>{{ form.financialSources }}</p>
          <span class="x-card-content-title">举办单位</span>
          <p>{{ form.sponsor }}</p>
          <span class="x-card-content-title">登记管理机关</span>
          <p>{{ form.registrationOrgan }}</p>
          <span class="x-card-content-title">原证书号</span>
          <p>{{ form.certificateID }}</p>
          <span class="x-card-content-title">统一社会信用代码</span>
          <p>{{ form.uniSocCreIdentifier }}</p>
          <span class="x-card-content-title">有效期</span>
          <p>{{ form.businessTerm }}</p>
          <span class="x-card-content-title">住所</span>
          <p>{{ form.registeredAddress }}</p>
          <span class="x-card-content-title">宗旨和业务范围</span>
          <p>{{ form.businessScope }}</p>
        </div>
        <div class="x-card-content" v-if="form.type == '中国香港'">
          <span class="x-card-content-title">商业登记号码</span>
          <p>{{ form.busRegistrationNumber }}</p>
          <span class="x-card-content-title">企业名称</span>
          <p>{{ form.name }}</p>
          <p v-if="form.englishName">{{ form.englishName }}</p>
          <span class="x-card-content-title">企业编号</span>
          <p>{{ form.uniSocCreIdentifier }}</p>
          <span class="x-card-content-title">企业状态</span>
          <p>{{ form.registrationStatus }}</p>
          <span class="x-card-content-title">成立日期</span>
          <p>{{ form.establishmentDate }}</p>
          <span class="x-card-content-title">企业类型</span>
          <p>{{ form.enterpriseType }}</p>
          <span class="x-card-content-title">企业地址</span>
          <p>{{ form.registeredAddress }}</p>
        </div>
        <div class="x-card-content" v-if="form.type == '中国台湾'">
          <span class="x-card-content-title">企业名称</span>
          <p>{{ form.name }}</p>
          <span class="x-card-content-title">英文名称</span>
          <p>{{ form.englishName }}</p>
          <span class="x-card-content-title">负责人</span>
          <p>{{ form.legalRepresentative }}</p>
          <span class="x-card-content-title">负责人职位</span>
          <p>{{ form.dutyerJob }}</p>
          <span class="x-card-content-title">公司现状</span>
          <p>{{ form.registrationStatus }}</p>
          <span class="x-card-content-title">行业</span>
          <p>{{ form.industry }}</p>
          <span class="x-card-content-title">辅助业务</span>
          <p>{{ form.assistBusiness }}</p>
          <span class="x-card-content-title">登记机关</span>
          <p>{{ form.registrationOrgan }}</p>
          <span class="x-card-content-title">核准设立日期</span>
          <p>{{ form.establishmentDate }}</p>
          <span class="x-card-content-title">最后核准变更日期</span>
          <p>{{ form.lastChangeDate }}</p>
          <span class="x-card-content-title">所在地区</span>
          <p>{{ form.area }}</p>
          <span class="x-card-content-title">员工人数</span>
          <p>{{ form.staffSize }}</p>
          <span class="x-card-content-title">电话号码</span>
          <p>{{ form.phoneNumber }}</p>
          <span class="x-card-content-title">股权状态</span>
          <p>{{ form.equityStatus }}</p>
          <span class="x-card-content-title">资本总额</span>
          <p>{{ form.registeredCapital }}</p>
          <span class="x-card-content-title">实收资本额</span>
          <p>{{ form.paidInAmount }}</p>
          <span class="x-card-content-title">统一编号</span>
          <p>{{ form.uniSocCreIdentifier }}</p>
          <span class="x-card-content-title">销售额(元)</span>
          <p>{{ form.salesAmount }}</p>
          <span class="x-card-content-title">销售额(美元)</span>
          <p>{{ form.salesAmountDollar }}</p>
          <span class="x-card-content-title">公司所在地</span>
          <p>{{ form.registeredAddress }}</p>
          <span class="x-card-content-title">经营范围</span>
          <p>{{ form.businessScope }}</p>
        </div>
        <div class="empty" v-if="!form.type || form.type == ''">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "", //企业名称、单位名称
        englishName: "", //英文名称
        legalRepresentative: "", //法定代表人、负责人
        dutyerJob: "", //负责人职称
        uniSocCreIdentifier: "", //统一社会信用代码、企业编号、统一编号
        busRegistrationNumber: "", //工商注册号、商业登记号码
        businessTerm: "", //营业期限、有效期
        enterpriseType: "", //企业类型
        insuredNumber: "", //参保人数
        registrationOrgan: "", //登记机关、登记管理机关
        businessScope: "", //经营范围、宗旨和业务范围
        registrationStatus: "", //登记状态、公司现状、企业状态
        establishmentDate: "", //成立日期、核准设立日期
        lastChangeDate: "", //最后核准变更日期
        registeredCapital: "", //注册资本、开办资金、资本总额
        financialSources: "", //经费来源
        certificateID: "", //原证书号
        sponsor: "", //举办单位
        taxRegistrationNumber: "", //纳税人识别号
        taxQualifications: "", //纳税人资质
        industry: "", //行业
        assistBusiness: "", //辅助业务
        area: "", //所在地区
        registeredAddress: "", //注册地址、住所、企业地址、公司所在地
        paidInAmount: "", //实缴资本、实收资本额
        orgInsBarCode: "", //组织机构代码
        staffSize: "", //人员规模、员工人数
        phoneNumber: "", //电话号码
        equityStatus: "", //股权状态
        salesAmount: "", //销售额（元）
        salesAmountDollar: "", //销售额（美元）
        type: "", //类型
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      let me = this,
        name = me.$route.query.name;
      if (!name || name == "") {
        return;
      }
      me.$loading({
        url: "/api/document/eBasicInformation/getBusinessInfo?name=" + name,
      }).then(function (res) {
        if (res.data) {
          me.form = res.data;
          if (me.form.type == "中国香港") {
            let str = me.form.name;
            let obj = me.splitAtFirstNewline(str);
            if (obj) {
              me.form.name = obj.before;
              me.form.englishName = obj.after;
            }
          }
        }
      });
    },
    splitAtFirstNewline(str) {
      const index = str.indexOf("\n");
      if (index === -1) return null; // 无换行符时返回null
      return {
        before: str.substring(0, index).replace(/\r$/, ""), // 截取换行符前内容并移除末尾\r
        after: str.substring(index + 1), // 截取换行符后内容
      };
    },
  },
};
</script>

<style scoped>
.page {
  background: #fff;
  margin-top: 50px;
  height: 100%;
}
.x-card-title {
  background: #f0f7fc;
  font-size: 16px;
  padding: 10px 10px;
  font-weight: 400;
  color: #0c88f1;
}
.x-card-content {
  padding: 4px 10px;
  font-size: 14px;
  color: #333;
}
.x-card-content-title {
  display: block;
  font-weight: bold;
  margin-top: 10px !important;
}

.empty {
  width: 100%;
  height: 300px;
  line-height: 300px;
  text-align: center;
  color: #727272;
  font-weight: bold;
  
}
</style>